export default {
  pageTitle: 'Value Chain Map',
  addNewValueChainMap: 'Add a new value chain map',
  createNewValueChainMap: 'Create new value chain map',
  searchByName: 'Search by name',
  filterByStatus: 'Filter by status',
  thereAreNoValueChanMaps: 'There are no Value Chain Maps yet',
  name: 'Name',
  createdDate: 'Created',
  lastModifiedAt: 'Last modified',
  status: 'Status',
  action: 'Actions',
  current: 'Current',
  inProgress: 'In progress',
  underReview: 'Under review',
  readyForReview: 'Ready for review',
  requestApproval: 'Request approval',
  requiresRework: 'Requires re-work',
  archived: 'Archived',
  edit: 'Edit',
  delete: 'Delete',
  copyOf: 'Copy of',
  rename: 'Rename',
  dublicate: 'Duplicate',
  archive: 'Archive',
  restore: 'Restore',
  processing: 'Processing...',
  actualRevenue: 'actual revenue: ',
  actualGrossMargin: 'actual gross profit: ',
  wipFinishedGoodsStock: 'Stock:',
  profitCentres: 'Profit Centres: ',
  Subsidiary: 'Subsidiary',
  JV: 'JV',
  AssociateSubsidiary: 'Associate Subsidiary',
  BusinessUnit: 'Business unit',
  Division: 'Division',
  businessStructure: 'Business Structure',
  valueChain: 'Value Chain',
  saved: 'Saved',
  showLog: 'Show change log',
  clickToRename: 'Click to rename',
  profitCenter: 'Profit Centre',
  profitCenterId: 'Profit Centre ID:',
  netBookValue: 'Allocated Net Book Value:',
  disablingReasonTitle: 'Specify reason for branch change',
  enablingReasonTitle: 'Specify reason for branch change',
  disablingReasonDescription: 'Please provide a reason for disabling or enabling the branch.',
  enablingReasonDescription: 'Please provide a reason for disabling or enabling the branch.',
  disabledBranchDetails: 'Disabled branch details',
  enableBranchDetails: 'Enable branch details',
  addProfitCentreToTheStructure: 'Add Profit Centre to the Business Structure',
  createNewProfitCentre: 'Create new profit centre',
  createNewOwnOperation: 'Create new own operation',
  addNewProfitCenter: 'Add new profit centre',
  addNewOwnOperation: 'Add new own operation',
  orSelectFromExistingProfitCentres:
    'OR Select from existing profit centres (unlinked or linked to physical own operation)',
  orSelectFromExistingOwnOperations: 'OR Select from existing own operations (logical)',
  addOperationToProfitCenter: 'Link Profit Centre to Own Operation',
  noResults: 'No results matching the defined criteria',
  connectionTypes: 'Connection Types',
  logical: 'Logical',
  financial: 'Financial',
  supplierOfGoods: 'Supplier of Goods',
  service: 'Service',
  manufacture: 'Manufacture',
  swimlane: 'Swimlane',
  filter: 'Filter',
  ownOperation: 'Balance Sheet Asset',
  inputProduct: 'Input Product',
  outputProduct: 'Output Product',
  product: 'Product',
  supplier: 'Supplier',
  customer: 'Customer',
  estimated: 'Estimated',
  industryNace: 'Industry (NACE):',
  country: 'Country of Operation / Incorporation:',
  bookValue: 'Net Book Value:',
  assetCategory: 'Asset Category:',
  keySupplierTier1Total: 'Supplier total cost:',
  relianceOnFreeNaturalResources: 'Reliance on \'free\' natural resources:',
  criticalityRating: 'Criticality Rating:',
  rawMaterialWipFinishedGoodsStock: 'Raw materials/WIP/Finished Goods Stock:',
  approved: 'Approved',
  connection: 'Connection',
  addConnection: 'Add Connection',
  removeConnection: 'Remove connection',
  connectionType: 'Connection Type',
  comment: 'Comment',
  ownershipPercentage: 'Ownership %',
  air: 'Air',
  sea: 'Sea',
  rail: 'Rail',
  van: 'Van',
  truck: 'Truck',
  rigidTruck: 'Rigid truck',
  arcticTruck: 'Arctic truck',
  distance: 'Distance',
  monetaryVolumes: 'Monetary volumes',
  unitMonetaryVolumes: 'Unit Monetary Volumes',
  quantity: 'Quantity',
  monetaryValues: 'Monetary values',
  typeOfServiceProvider: 'Type of Service Provider',
  unitCurrency: 'Unit Currency',
  minCharactersLength: 'Min Characters Length',
  maxCharactersLength: 'Max Characters Length',
  transportMethod: 'Transport Method',
  currency: 'Currency',
  unit: 'Unit',
  approve: 'Approve',
  returnForReWork: 'Return for re-work',
  reWorkReason: 'Please add a comment why this VC map requires re-work.',
  search: 'Search',
  organizational: 'Organizational',
  geographical: 'Geographical',
  relatedBalanceSheetAssets: 'Related Balance Sheet Assets (Actual | Calculated):',
  stock: 'Stock',
  naceSection: 'Sector (NACE):',
  addressCountry: 'Country of Operation / Incorporation:',
  balanceSheetAsset: 'Related balance sheet assets ( actual | calculated )',
  titleReWork: 'Share your feedback',
  ai: 'AI Agent',
  aiAgentsSidebarTitle: 'AI Agent',
  aiAgentsSidebarSupplierDiscoveryTitle: 'Supplier N-Tier Discovery',
  aiAgentsSidebarSupplierDiscoveryDescription:
    'AI assists in constructing the value chain by identifying suppliers across multiple tiers '
    + 'and mapping the connections between them. Helps reveal dependencies, risks, and supply chain structure.',
  aiAgentsSidebarSupplierRegulationTitle: 'Supplier Regulation Monitoring',
  aiAgentsSidebarSupplierRegulationDescription:
    'Tracks how and when new and evolving regulations impact your supply chain. '
    + 'Tariffs, duties, carbon pricing and much more.',
  aiAgentsSidebarProductRegulationTitle: 'Product Regulation Monitoring',
  aiAgentsSidebarProductRegulationDescription:
    'Tracks how evolving regulations, regulator actions, and policy rumors may impact '
    + 'selected products, materials, and manufacturing locations on your value chain.',
  aiAgentsSidebarPublicSentimentTitle: 'Public Sentiment Monitoring',
  aiAgentsSidebarPublicSentimentDescription:
    'Tracks media and public perception signals related to selected entities. '
    + 'Highlights reputation trends, spikes, and potential concerns.',
  aiAgentsSidebarFinancialStabilityTitle: 'Financial Stability Monitoring',
  aiAgentsSidebarFinancialStabilityDescription:
    'Analyzes financial indicators to detect stability and risk patterns. '
    + 'Supports early identification of potential disruptions.',
  aiAgentsSidebarNaturalDisasterTitle: 'Natural Disaster Forecast Monitoring',
  aiAgentsSidebarNaturalDisasterDescription:
    'Monitors environmental and disaster risks affecting operations or suppliers. '
    + 'Provides early warnings for climate-related disruptions.',
  aiAgentsSidebarClimateMonitoringTitle: 'Climate Monitoring',
  aiAgentsSidebarClimateMonitoringDescription:
    'Monitors climate, disaster, agri-disease, and trade-sanction risks at suppliers, '
    + 'Own Operations, and Balance Sheet Assets. Linked Input Products enrich each scan.',
  aiAgentsSidebarOwnershipMonitoringTitle: 'Ownership Monitoring',
  aiAgentsSidebarOwnershipMonitoringDescription:
    'Traces ultimate beneficial owners, parent entities, and related-group contagion risks. '
    + 'Helps detect shortage risk from corporate-group exposure.',
  aiAgentsSidebarIndustrialForecastTitle: 'Industrial Forecast Monitoring',
  aiAgentsSidebarIndustrialForecastDescription:
    'Tracks industry trends, demand shifts, and market dynamics. '
    + 'Helps anticipate changes impacting performance and strategy.',
  aiAgentsSidebarComingSoon: 'Coming soon',
  monitoringHubSessionsTab: 'Sessions',
  monitoringHubSchedulesTab: 'Schedules',
  monitoringHubTabsLabel: 'Monitoring hub sections',
  monitoringHubSchedulesComingSoon: 'Scheduled monitoring will be available in a future update.',
  monitoringHubNewSelection: 'New selection',
  monitoringHubNewSchedule: 'New schedule',
  monitoringHubSearchPlaceholder: 'Search sessions...',
  monitoringHubSchedulesSearchPlaceholder: 'Search schedules...',
  monitoringScheduleConfigTitle: 'Configure schedule',
  monitoringScheduleEditTitle: 'Edit schedule',
  monitoringScheduleSave: 'Save schedule',
  monitoringScheduleUpdate: 'Update schedule',
  monitoringScheduleEdit: 'Edit',
  monitoringScheduleUpdateError: 'Unable to update schedule. Please try again.',
  monitoringSchedulesOpenModal: 'Open schedules',
  monitoringSchedulesOpenModalHint:
    'Browse every monitoring schedule for this value chain map and inspect run history in one place.',
  monitoringSchedulesModalTitle: 'Schedules',
  monitoringSchedulesModalHint:
    'Select a schedule to edit settings or open execution history.',
  monitoringSchedulesModalHistoryHint:
    'Run history shows executions, units, and findings. Use Run now from the history panel.',
  monitoringSchedulesModalCount_one: '{{count}} schedule',
  monitoringSchedulesModalCount_other: '{{count}} schedules',
  monitoringSchedulesModalPausedCount_one: '{{count}} paused',
  monitoringSchedulesModalPausedCount_other: '{{count}} paused',
  monitoringSchedulesModalSelectHint: 'Select a schedule from the table to edit or open history.',
  monitoringSchedulesModalColTitle: 'Title',
  monitoringSchedulesModalColRecurrence: 'Recurrence',
  monitoringSchedulesModalColEntities: 'Entities',
  monitoringSchedulesModalColNextRun: 'Next run',
  monitoringSchedulesModalColLastStatus: 'Last status',
  monitoringSchedulePreview: 'Schedule preview',
  monitoringScheduleModeRecurring: 'Recurring',
  monitoringScheduleTimezone: 'Timezone',
  monitoringScheduleFrequency: 'Frequency',
  monitoringScheduleFrequencyDaily: 'Daily',
  monitoringScheduleFrequencyWeekly: 'Weekly',
  monitoringScheduleFrequencyMonthly: 'Monthly',
  monitoringScheduleInterval: 'Repeat every',
  monitoringScheduleDaysOfWeek: 'Days of week',
  monitoringScheduleTimeOfDay: 'Hour of day',
  monitoringScheduleTimeOfDayHint: 'Runs at the start of the selected hour (minutes are not configurable).',
  monitoringScheduleStartDate: 'Start date',
  monitoringScheduleEndDate: 'End date',
  monitoringScheduleNoEndDate: 'No end date',
  monitoringScheduleTimezoneSearch: 'Search timezones',
  monitoringScheduleIntervalEvery: 'Every {{count}} {{unit}}',
  monitoringScheduleIntervalDay_one: 'day',
  monitoringScheduleIntervalDay_other: 'days',
  monitoringScheduleIntervalWeek_one: 'week',
  monitoringScheduleIntervalWeek_other: 'weeks',
  monitoringScheduleIntervalMonth_one: 'month',
  monitoringScheduleIntervalMonth_other: 'months',
  monitoringScheduleValidationRequired: 'This field is required',
  monitoringScheduleValidationDaysOfWeek: 'Select at least one day',
  monitoringScheduleValidationStartDatePast: 'Start date must be today or later',
  monitoringScheduleValidationEndDateBeforeStart: 'End date must be on or after start date',
  monitoringScheduleValidationIntervalMin: 'Interval must be at least 1',
  monitoringScheduleValidationHourOnly: 'Choose a whole hour (minutes must be :00).',
  monitoringScheduleSaveError: 'Unable to save schedule. Please try again.',
  monitoringSchedulesEmpty: 'No schedules yet. Create one to monitor entities automatically.',
  monitoringSchedulesLoadError: 'Unable to load schedules. Please try again.',
  boardLoadError: 'Unable to load the map. Please try again.',
  monitoringScheduleNextRun: 'Next',
  monitoringScheduleLastRun: 'Last',
  monitoringScheduleEntityCount_one: '{{count}} entity',
  monitoringScheduleEntityCount_other: '{{count}} entities',
  monitoringScheduleProductCount_one: '{{count}} product',
  monitoringScheduleProductCount_other: '{{count}} products',
  monitoringScheduleOpenRunHistory: 'Open run history',
  monitoringScheduleDelete: 'Delete schedule',
  monitoringScheduleDeleteModalTitle: 'Delete monitoring schedule',
  monitoringScheduleDeleteModalDescription: 'This will permanently remove the schedule and its run history.',
  monitoringScheduleDeleteError: 'Unable to delete schedule. Please try again.',
  monitoringSchedulePause: 'Pause',
  monitoringScheduleResume: 'Resume',
  monitoringScheduleResumeUnavailable: 'Resume unavailable — assign an agent template first',
  monitoringScheduleMissingTemplate: 'Template removed — edit schedule to pick a new template before resume',
  monitoringSchedulePausedBadge: 'Paused',
  agentTemplateLabel: 'Agent template',
  agentTemplateBomLabel: 'BOM template',
  agentTemplateSupplierLabel: 'Supplier Investigation template',
  agentTemplateBomStepTitle: 'Select BOM template',
  agentTemplateSupplierStepTitle: 'Select Supplier Investigation template',
  agentTemplateStepDescription: 'Choose which agent template to run for this selection.',
  agentTemplateStepTitleMonitoring: 'Select template',
  agentTemplateStepDescriptionMonitoring:
    'Choose an agent template to create this session. Map units unlock after the session exists.',
  agentTemplateConfirmStart: 'Start with selected template',
  agentTemplateConfirmCreate: 'Continue with selected template',
  agentTypeStepTitle: 'Choose discovery type',
  agentTypeStepDescription:
    'Choose Bill of Materials or Supplier Investigation first. That choice sets which map '
    + 'lanes you can select after the session is created.',
  agentTemplatePlaceholder: 'Select a template',
  agentTemplateLoadError: 'Unable to load templates. Please try again.',
  agentTemplateEmpty: 'No eligible templates for this agent type.',
  agentTemplateNotRunnable: 'Not runnable yet',
  agentTemplateRunnable: 'Runnable',
  agentTemplateRunnableWarning:
    'This template is enabled but not runnable yet. You can still assign it; '
    + 'runs may fail until the agent pipeline is available.',
  agentTemplateRequired: 'Select an agent template to continue.',
  agentTemplateRequiredForExistingSession:
    'This session needs an agent template before Generate with AI. Pick one to continue.',
  aiPanelSelectionRequired: 'Select at least one unit before starting with a template.',
  agentTemplateSelected: 'Selected',
  agentTemplateVersion: 'v{{version}}',
  agentTemplateRunsBadge_one: '{{count}} run',
  agentTemplateRunsBadge_other: '{{count}} runs',
  agentTemplateSuccessBadge: '{{value}}% success',
  agentTemplateConfirmed: {
    materials_one: '{{count}} material',
    materials_other: '{{count}} materials',
    suppliers_one: '{{count}} supplier',
    suppliers_other: '{{count}} suppliers',
    findings_one: '{{count}} finding',
    findings_other: '{{count}} findings',
    signals_one: '{{count}} signal',
    signals_other: '{{count}} signals',
    regulations_one: '{{count}} regulation',
    regulations_other: '{{count}} regulations',
    exposures_one: '{{count}} exposure',
    exposures_other: '{{count}} exposures',
    entities_one: '{{count}} entity',
    entities_other: '{{count}} entities',
  },
  agentTemplateTrend: {
    up: 'Improving',
    flat: 'Stable',
    down: 'Declining',
  },
  agentTemplateInsightsNote:
    'Usage figures are illustrative because this environment has not returned template metrics yet.',
  agentTemplateType: {
    bom: 'BOM',
    supplierInvestigation: 'Supplier Investigation',
    reputationMonitoring: 'Public Sentiment',
    regulationMonitoring: 'Product Regulation',
    financeMonitoring: 'Financial Stability',
    climateMonitoring: 'Climate',
    ownershipMonitoring: 'Ownership',
  },
  monitoringSchedulePauseError: 'Unable to pause schedule. Please try again.',
  monitoringScheduleResumeError: 'Unable to resume schedule. Please try again.',
  monitoringRunHistoryLoadError: 'Unable to load run history. Please try again.',
  monitoringRunHistoryEmpty: 'No runs recorded for this schedule yet.',
  monitoringRunHistoryNoFilterMatch: 'No runs match the current filters.',
  monitoringRunStatusAll: 'All',
  monitoringRunStatusFilter: 'Filter by status',
  monitoringRunDateFilter: 'Filter by date range',
  monitoringRunDateFrom: 'From',
  monitoringRunDateTo: 'To',
  monitoringRunId: 'Run ID',
  monitoringRunScheduledAt: 'Scheduled',
  monitoringRunStartedAt: 'Started',
  monitoringRunStatusColumn: 'Status',
  monitoringRunAlerts: 'Alerts',
  monitoringRunAction: 'Action',
  monitoringRunLabel: 'Run {{date}}',
  monitoringResultsTitle: 'Monitoring results',
  monitoringResultsAlerts: 'Alerts',
  monitoringResultsEmpty: 'No monitoring results available.',
  monitoringRunHistoryTitle: 'Run history',
  /* The panel's header shows the session name. This names the panel itself, for the AI context. */
  monitoringResultsPanelTitle: 'Monitoring results',
  monitoringRunStatusCompleted: 'Completed',
  monitoringRunStatusRunning: 'Running',
  monitoringRunStatusFailed: 'Failed',
  monitoringRunStatusSkipped: 'Skipped',
  monitoringRunStatusPending: 'Pending',
  monitoringRunStatusPartial: 'Partial',
  monitoringScheduleRunNow: 'Run now',
  monitoringScheduleRunNowHint: 'Starts an immediate monitoring run for every unit on this schedule.',
  monitoringScheduleRunNowPaused: 'Resume the schedule before using Run now.',
  monitoringScheduleRunNowSuccess: 'Monitoring run started.',
  monitoringScheduleRunNowError: 'Unable to start Run now. Please try again.',
  monitoringScheduleImpactTitle: 'Impact Scenario automation',
  monitoringScheduleImpactHint:
    'When enabled, elevated findings from this schedule can auto-create Impact Scenarios.',
  monitoringScheduleAutoCreateImpact: 'Auto-create Impact Scenarios',
  monitoringScheduleImpactMinSeverity: 'Minimum severity',
  monitoringScheduleImpactSeverityRequired: 'Select a minimum severity for auto-create.',
  monitoringFindingSeverityMedium: 'Medium',
  monitoringFindingSeverityHigh: 'High',
  monitoringFindingSeverityCritical: 'Critical',
  monitoringExecutionHistoryEmpty: 'No executions yet. Use Run now or wait for the next scheduled tick.',
  monitoringSessionHistoryEmpty: 'No executions yet. Start monitoring to create a run for this session.',
  monitoringExecutionScheduledAt: 'Execution',
  monitoringExecutionTrigger: 'Trigger',
  monitoringExecutionTriggerManual: 'Run now',
  monitoringExecutionTriggerSessionStart: 'Start',
  monitoringExecutionTriggerScheduled: 'Scheduled',
  monitoringExecutionUnits: 'Units',
  monitoringExecutionViewUnits: 'View units',
  monitoringExecutionUnitsTitle: 'Execution units',
  monitoringExecutionUnitsEmpty: 'No unit runs for this execution yet.',
  monitoringExecutionUnitName: 'Unit',
  monitoringFindingsTitle: 'Findings',
  monitoringFindingsCount: 'Findings',
  monitoringFindingsSummary: 'Run summary',
  monitoringFindingsEmpty: 'No findings yet for this unit run. Results appear after the Lambda finishes.',
  monitoringFindingSource: 'Open source',
  monitoringFindingLinkedImpact: 'Linked Impact Scenario #{{id}}',
  monitoring: {
    hub: {
      placeholder: 'Sessions and schedules will appear here in the next release step.',
    },
    reputation: {
      title: 'Public Sentiment Monitoring',
      sessionTitle: {
        current: 'Current Sentiment Monitoring',
        previous: 'Previous Sentiment Monitoring',
      },
      generating: 'Scanning public channels…',
      generatingDescription:
        'We are checking public channels for sentiment signals on your selected suppliers.',
      resultsPlaceholder: 'Matched articles and risk summary will appear here after a monitoring run completes.',
      metricLabel: 'Sentiment index',
      sessionsInfo:
        'Run on-demand sentiment scans for selected suppliers. Pick entities on the canvas, then start monitoring.',
      schedulesInfo:
        'Configure autonomous recurring monitoring. Each schedule runs media-sentiment scans on '
        + 'your selected entities.',
      selectionInfo:
        'Select any supplier card in the Upstream section on the canvas to monitor.',
      selectionEmpty: 'Click upstream supplier cards on the canvas to select entities for monitoring.',
      selectionTitle: 'Select entities',
      startMonitoring: 'Start monitoring now',
      continueToSchedule: 'Continue to schedule',
      impactBridgeCta: 'Create impact scenario from these results',
      impactBridgeCtaDescription:
        'Model supply-chain impact for suppliers flagged as high risk in this monitoring run.',
      impactBridgeScenarioName: 'Sentiment risk — {{date}}',
    },
    regulation: {
      title: 'Product Regulation Monitoring',
      sessionTitle: {
        current: 'Current Product Regulation Monitoring',
        previous: 'Previous Product Regulation Monitoring',
      },
      generating: 'Scanning regulatory feeds…',
      generatingDescription:
        'We are checking regulatory feeds for policy signals on your selected products.',
      resultsPlaceholder:
        'Regulation findings and impact summary will appear here after a monitoring run completes.',
      metricLabel: 'Impact level',
      sessionsInfo:
        'Run on-demand regulation scans for selected input or output products. '
        + 'Pick product cards on the canvas, then start monitoring.',
      schedulesInfo:
        'Configure autonomous recurring monitoring. Each schedule runs regulation-tracking scans '
        + 'on selected products and their material/location context.',
      selectionInfo:
        'Click any Input Product card in the Upstream section or any Output Product card in '
        + 'Own Operations to select products for monitoring.',
      selectionEmpty:
        'Click input-product or output-product cards on the canvas to select products for monitoring.',
      selectionTitle: 'Select products',
      startMonitoring: 'Start monitoring now',
      continueToSchedule: 'Continue to schedule',
      impactBridgeCta: 'Create impact scenario from these results',
      impactBridgeCtaDescription:
        'Model supply-chain impact for products with high or critical regulation findings.',
      impactBridgeScenarioName: 'Regulation risk — {{date}}',
    },
    finance: {
      title: 'Financial Stability Monitoring',
      sessionTitle: {
        current: 'Current Financial Monitoring',
        previous: 'Previous Financial Monitoring',
      },
      generating: 'Analyzing financial indicators…',
      generatingDescription:
        'We are analyzing financial stability indicators for your selected suppliers.',
      resultsPlaceholder:
        'Financial profiles, bankruptcy status, and risk findings will appear here after a monitoring run completes.',
      metricLabel: 'Stability index',
      sessionsInfo:
        'Run on-demand financial stability scans for selected suppliers. '
        + 'Review 5-year Revenue, EBITDA, Liquidity retention, and bankruptcy status.',
      schedulesInfo:
        'Configure autonomous recurring monitoring. Each schedule runs financial-risk scans '
        + 'on your selected upstream suppliers.',
      selectionInfo:
        'Select any supplier card in the Upstream section on the canvas to monitor.',
      selectionEmpty: 'Click upstream supplier cards on the canvas to select entities for monitoring.',
      selectionTitle: 'Select entities',
      startMonitoring: 'Start monitoring now',
      continueToSchedule: 'Continue to schedule',
      impactBridgeCta: 'Create impact scenario from these results',
      impactBridgeCtaDescription:
        'Model supply-chain impact for suppliers flagged as high financial risk in this monitoring run.',
      impactBridgeScenarioName: 'Financial risk — {{date}}',
    },
    ownership: {
      title: 'Ownership Monitoring',
      sessionTitle: {
        current: 'Current Ownership Monitoring',
        previous: 'Previous Ownership Monitoring',
      },
      generating: 'Analyzing ownership and corporate-group exposure…',
      generatingDescription:
        'We are tracing ultimate beneficial owners, parent entities, and related-group contagion '
        + 'for your selected suppliers.',
      resultsPlaceholder:
        'Ownership profiles, contagion findings, and investigation trails will appear here '
        + 'after a monitoring run completes.',
      metricLabel: 'Contagion index',
      sessionsInfo:
        'Run on-demand ownership contagion scans for selected suppliers. '
        + 'Review UBO / parent links, group exposure, and related-entity risk findings.',
      schedulesInfo:
        'Configure autonomous recurring monitoring. Each schedule runs ownership contagion scans '
        + 'on your selected upstream suppliers.',
      selectionInfo:
        'Select any supplier card in the Upstream section on the canvas to monitor.',
      selectionEmpty: 'Click upstream supplier cards on the canvas to select entities for monitoring.',
      selectionTitle: 'Select entities',
      startMonitoring: 'Start monitoring now',
      continueToSchedule: 'Continue to schedule',
      impactBridgeCta: 'Create impact scenario from these results',
      impactBridgeCtaDescription:
        'Model supply-chain impact for suppliers flagged as high ownership contagion risk in this monitoring run.',
      impactBridgeScenarioName: 'Ownership contagion — {{date}}',
      impactBridgeCtaFromSupplier: 'Create impact scenario for this supplier',
      impactBridgeCtaFromSupplierDescription:
        'Model supply-chain impact for the selected supplier based on ownership contagion findings.',
    },
    climate: {
      title: 'Climate Monitoring',
      sessionTitle: {
        current: 'Current Climate Monitoring',
        previous: 'Previous Climate Monitoring',
      },
      generating: 'Analyzing climate and disaster exposure…',
      generatingDescription:
        'We are scanning geo hazards, product-location risks, and trade advisories '
        + 'for your selected suppliers, Own Operations, and Balance Sheet Assets.',
      resultsPlaceholder:
        'Exposure profiles, hazard findings, and shortage trails will appear here '
        + 'after a monitoring run completes.',
      metricLabel: 'Exposure score',
      sessionsInfo:
        'Run on-demand climate and disaster scans for selected suppliers, Own Operations, '
        + 'and Balance Sheet Assets. Linked Input Products are included automatically.',
      schedulesInfo:
        'Configure autonomous recurring monitoring. Each schedule runs climate / disaster scans '
        + 'on your selected entities.',
      selectionInfo:
        'Click <strong>suppliers</strong> (Upstream, any tier), <strong>Own Operations</strong>, '
        + 'or <strong>Balance Sheet Asset</strong> cards to monitor climate and disaster risk. '
        + 'Linked Input Products are included automatically.',
      selectionEmpty:
        'Click supplier, Own Operations, or Balance Sheet Asset cards on the canvas to select '
        + 'entities for monitoring.',
      selectionTitle: 'Select entities',
      startMonitoring: 'Start monitoring now',
      continueToSchedule: 'Continue to schedule',
      impactBridgeCta: 'Create impact scenario from these results',
      impactBridgeCtaDescription:
        'Model supply-chain impact for entities flagged as high climate or disaster risk '
        + 'in this monitoring run.',
      impactBridgeScenarioName: 'Climate risk — {{date}}',
      impactBridgeCtaFromEntity: 'Create impact scenario for this entity',
      impactBridgeCtaFromEntityDescription:
        'Model supply-chain impact for the selected entity based on climate hazard findings.',
      impactBridgeCtaFiltered: 'Create impact scenario from {{theme}} findings',
      impactBridgeCtaFilteredDescription:
        'Model supply-chain impact for entities impacted by the selected disaster theme.',
    },
    results: {
      viewResults: 'View results',
      breadcrumbLabel: 'Results navigation',
      summaryLine: '{{totalArticles}} articles found · {{highRiskCount}} high risk',
      regulationSummaryLine:
        '{{totalResults}} regulations found · {{highImpactCount}} high · {{criticalImpactCount}} critical',
      topKeywords: 'Top keywords',
      keywords: 'Keywords',
      confidence: '{{value}}% confidence',
      loadError: 'Unable to load monitoring results. Please try again.',
      noArticles: 'No articles found for this monitoring run.',
      noRegulations: 'No regulations found for this monitoring run.',
      noFinanceFindings: 'No financial findings for this monitoring run.',
      noOwnershipFindings: 'No ownership contagion findings for this monitoring run.',
      noClimateFindings: 'No climate hazard findings for this monitoring run.',
      financeSummaryLine:
        '{{entitiesMonitored}} suppliers · {{totalFindings}} findings · {{highRiskCount}} high risk',
      ownershipSummaryLine:
        '{{entitiesMonitored}} suppliers · {{totalFindings}} findings · {{highRiskCount}} high risk',
      climateSummaryLine:
        '{{entitiesMonitored}} entities · {{totalFindings}} findings · {{highRiskCount}} high risk',
      climateExposureScore: 'Exposure {{value}}',
      climateSpike: 'Spike',
      climateFindingsFeed: 'Findings feed',
      climateEntitiesSection: 'Exposure profiles',
      climateOpenAnalysis: 'Open climate analysis',
      climateOpenAnalysisHint:
        'Review geo exposure, linked materials, and hazard trails before diving into profiles or findings.',
      climateResultsTabsLabel: 'Climate results sections',
      climateProfilesTab: 'Exposure profiles',
      climateFindingsTab: 'Findings feed',
      climateAnalysisTitle: 'Climate analysis',
      climateLocation: 'Location',
      climateMaterials: 'Linked materials',
      climateHazards: 'Active hazards',
      climateHorizon: 'Horizon',
      climateShortageRisk: 'Shortage / downtime risk',
      climateRecommendedAction: 'Action',
      climateImpactTrail: 'Impact trail',
      climateAllThemes: 'All',
      climateEntityKind: {
        supplier: 'Supplier',
        'own-operation': 'Own Operations',
        'balance-sheet-asset': 'Balance Sheet Asset',
      },
      climateModalKind: 'Kind',
      climateModalLocation: 'Location',
      climateModalExposure: 'Exposure',
      climateModalTrend: 'Trend',
      climateModalMaterials: 'Materials',
      climateModalSummaryTab: 'Summary',
      climateModalDiagramTab: 'Diagram',
      climateModalHint:
        'Filter by disaster theme, then select an entity to inspect Summary or Diagram A '
        + '(schematic VCM trail).',
      climateModalKpiEntities: '{{count}} entities',
      climateModalKpiFindings: '{{count}} findings',
      climateModalKpiHighRisk: '{{count}} high risk',
      climateModalIssueCount: '{{count}} issue(s)',
      climateModalSelectIssue: 'Select an issue to inspect its summary or diagram.',
      climateModalObserved: 'Observed',
      climateModalConfidence: 'Confidence',
      climateModalHorizon: 'Horizon',
      climateModalTrailInterpretation: 'Trail interpretation',
      climateTrend: {
        declining: 'Declining',
        stable: 'Stable',
        rising: 'Rising',
      },
      climateTheme: {
        flood: 'Flood',
        storm: 'Storm',
        heat: 'Heat',
        wildfire: 'Wildfire',
        earthquake: 'Earthquake',
        drought: 'Drought',
        'crop-disease': 'Crop disease',
        'animal-disease': 'Animal disease',
        'trade-sanctions': 'Trade sanctions',
        'other-climate': 'Other',
      },
      ownershipContagionScore: 'Contagion {{value}}',
      ownershipSpike: 'Spike',
      ownershipFindingsFeed: 'Findings feed',
      ownershipEntitiesSection: 'Supplier ownership profiles',
      ownershipOpenAnalysis: 'Open ownership analysis',
      ownershipOpenAnalysisHint:
        'Review the group investigation tree and issue trails before diving into profiles or findings.',
      ownershipResultsTabsLabel: 'Ownership results sections',
      ownershipProfilesTab: 'Supplier ownership profiles',
      ownershipFindingsTab: 'Findings feed',
      ownershipAnalysisTitle: 'Ownership analysis',
      ownershipUbo: 'Ultimate beneficial owner',
      ownershipDirectParent: 'Direct parent',
      ownershipCorporateGroup: 'Corporate group',
      ownershipRelatedScanned: 'Related entities scanned',
      ownershipRelatedFlagged: 'Related entities flagged',
      ownershipLinkPath: 'Ownership link path',
      ownershipContagionMechanism: 'Contagion mechanism',
      ownershipShortageRisk: 'Shortage risk',
      ownershipRecommendedAction: 'Action',
      ownershipAllThemes: 'All',
      ownershipModalGroup: 'Group',
      ownershipModalContagion: 'Contagion',
      ownershipModalTrend: 'Trend',
      ownershipModalExposure: 'Exposure',
      ownershipModalSummaryTab: 'Summary',
      ownershipModalDiagramTab: 'Diagram',
      ownershipModalHint:
        'Expand a supplier to inspect parent, UBO, sister companies, and nested operating sites — '
        + 'then open Summary or Diagram for each issue.',
      ownershipModalKpiSuppliers: '{{count}} suppliers',
      ownershipModalKpiFindings: '{{count}} findings',
      ownershipModalKpiHighRisk: '{{count}} high risk',
      ownershipModalIssueCount: '{{count}} issue(s)',
      ownershipModalLinkedCount: '{{count}} linked',
      ownershipModalNoNodes: 'No ownership investigation nodes for this supplier.',
      ownershipModalSelectIssue: 'Select an issue to inspect its summary or diagram.',
      ownershipModalObserved: 'Observed',
      ownershipModalConfidence: 'Confidence',
      ownershipModalImpact: 'Impact',
      ownershipModalTrailInterpretation: 'Trail interpretation',
      ownershipTrend: {
        declining: 'Declining',
        stable: 'Stable',
        rising: 'Rising',
      },
      ownershipTheme: {
        'reputation-contagion': 'Reputation',
        'labour-rights': 'Labour',
        environmental: 'Environmental',
        governance: 'Governance',
        sanctions: 'Sanctions',
        operational: 'Operational',
        'ownership-change': 'Ownership change',
      },
      financeLiquidityFormula:
        'Liquidity retention = liquid assets ÷ current liabilities '
        + '(buffer ratio; < 1.0x = elevated short-term pressure)',
      financeProfileCaption: 'Year 1 = most recent · Liquidity retention = liquid assets ÷ current liabilities',
      financeRevenue: 'Revenue',
      financeEbitda: 'EBITDA',
      financeLiquidityRetention: 'Liquidity',
      financeLiquidityRetentionFull: 'Liquidity retention',
      financeFindingsFeed: 'Findings feed',
      financeEntitiesSection: 'Supplier profiles',
      financeShortageRisk: 'Shortage risk',
      financeRecommendedAction: 'Action',
      financeBankruptcyClear: 'No bankruptcy protection or judicial reorganization',
      financeProtectionActive: 'Bankruptcy protection / reorganization active',
      financeStabilityScore: 'Stability {{value}}',
      financeYear: 'Year',
      financeAllThemes: 'All',
      financeTrend: {
        declining: 'Declining',
        stable: 'Stable',
        improving: 'Improving',
      },
      financeTheme: {
        liquidity: 'Liquidity',
        credit: 'Credit',
        solvency: 'Solvency',
        insolvency: 'Insolvency',
        'payment-behaviour': 'Payment',
        market: 'Market',
        capacity: 'Capacity',
        earnings: 'Earnings',
      },
      factoryLocation: 'Factory location',
      relatedMaterials: 'Related materials',
      enactedDate: 'Enacted',
      effectiveDate: 'Effective',
      expectedEnforcementDate: 'Expected enforcement',
      sources: 'Sources',
      sentiment: {
        negative: 'Negative',
        neutral: 'Neutral',
        positive: 'Positive',
      },
      riskSeverity: {
        low: 'Low risk',
        medium: 'Medium risk',
        high: 'High risk',
        critical: 'Critical risk',
      },
      impactLevel: {
        low: 'Low impact',
        medium: 'Medium impact',
        high: 'High impact',
        critical: 'Critical impact',
      },
      sourceType: {
        official: 'Official',
        industry: 'Industry',
        media: 'Media',
        'legal-analysis': 'Legal analysis',
      },
      approvalState: {
        rumor: 'Rumor',
        'under-review': 'Under review',
        'approved-not-effective': 'Approved, not effective',
        'in-force': 'In force',
        'enforcement-action': 'Enforcement action',
      },
    },
  },
  aiPanelTitle: 'Supplier N-Tier Discovery',
  aiPanelSelected: 'Selected',
  aiPanelDescription:
    'Select the entities you want to make a discovery for on the board or use search. '
    + 'The entities must be of the same type and be in the same column',
  aiPanelSearchPlaceholder: 'Search by name...',
  aiSessionsTitle: 'Sessions',
  aiSessionsNewSelection: 'New selection',
  aiSessionsCurrentSelection: 'Current Selection',
  aiSessionsCurrentSupplierSearch: 'Current Supplier Search',
  aiSessionsCurrentBomInvestigation: 'Current BOM Investigation',
  aiSessionsPreviousSelection: 'Previous Selection',
  aiSessionsPreviousSupplierSearch: 'Previous Supplier Search',
  aiSessionsPreviousBomInvestigation: 'Previous BOM Investigation',
  aiSessionsSelectedEntities: 'Selected Entities',
  aiSessionsNoSelectedEntities: 'No selected entities',
  aiSessionsEmpty: 'There are no sessions yet.',
  aiSessionsLoadError: 'Unable to load sessions. Please try again.',
  aiSessionsEditSession: 'Edit session',
  aiSessionsDeleteSession: 'Delete session',
  aiSessionsDeleted: 'Session has been deleted.',
  aiSessionsDeleteModalTitle: 'Are you sure you want to delete this session?',
  aiSessionsDeleteModalDescription: 'This action cannot be undone.',
  aiSessionsFallbackEntityName: 'Entity #{{id}}',
  aiPanelAnalyzeBom: 'Analyze BOM',
  aiPanelSearchSuppliers: 'Search Suppliers',
  bomUnitsModalTitle: 'Bill of Materials',
  bomUnitsGenerateWithAI: 'Generate with AI',
  bomUnitsGenerateWithAIForAllItems: 'For all items',
  bomUnitsGenerateWithAIForCurrentOnly: 'For current only',
  bomUnitsUploadFile: 'Upload File',
  bomUnitsUploadModalTitle: 'Upload file',
  bomUnitsUploadDropzoneTitle: 'Choose a file or drag a file here',
  bomUnitsUploadDropzoneSubtitle: 'Accepted formats: xlsx. Maximum upload size: 5MB',
  bomUnitsAddRecord: 'Add Record',
  bomUnitsManufacturedBy: 'Manufactured by:',
  bomUnitsDeliveredToPrefix: 'Supplied to:',
  bomUnitsAddManufacturer: 'Add manufacturer',
  bomUnitsSelectAll: 'Select all',
  bomUnitsScrollLeft: 'Scroll tabs left',
  bomUnitsScrollRight: 'Scroll tabs right',
  bomUnitsInputProduct: 'Input Product*',
  bomUnitsCode: 'Internal Code*',
  bomUnitsDescription: 'Description',
  bomUnitsCategory: 'Category',
  bomUnitsSuppliers: 'Suppliers*',
  bomUnitsNaceSector: 'NACE Sector',
  bomUnitsAdditionalInformation: 'Additional information',
  bomUnitsSource: 'Source',
  bomUnitsEmptyState:
    'You have not added any input products yet.\n'
    + 'You can create them using AI, upload a file,\n'
    + 'or create them manually.',
  bomUnitsNoSelectionForAllTabs:
    'Some items are missing manufacturers or suppliers and will be skipped during generation.',
  supplierUnitsModalTitle: 'Suppliers Investigation',
  supplierUnitsSupplierName: 'Supplier Name*',
  supplierUnitsCode: 'Supplier Code*',
  supplierUnitsLocation: 'Location*',
  supplierUnitsHq: 'HQ',
  supplierUnitsGoodsType: 'Goods Type',
  supplierUnitsWebsite: 'Website',
  supplierUnitsNaceSector: 'NACE Sector',
  supplierUnitsSource: 'Source',
  supplierUnitsEditCell: 'Edit supplier field',
  supplierUnitsEmptyState:
    'You have not added any suppliers yet.\n'
    + 'You can create them using AI or create them manually.',
  bomUnitsAnalysisInProgressTitle: 'Analysis in progress…',
  bomUnitsAnalysisInProgressDescription:
    'Your data is being processed.\nGenerated items will appear shortly.',
  aiPanelResetAllTitle: 'Reset all selections',
  aiPanelResetAllDescription:
    'This will reset all settings to their default values. Any changes you made will be lost.',
  aiPanelMissingCardsError:
    'Please create Balance Sheets Assets first. '
    + 'You can do it on the current Value Chain Map with a button in the sidebar OR in',
  aiPanelBalanceSheetAssetsLink: 'Settings/Data Sets Management/Balance Sheet Assets',
  aiGeneratingModalTitle: 'AI Generating ...',
  aiGeneratingMonitoringModalTitle: 'Scanning public channels…',
  aiGeneratingMonitoringModalDescription:
    'We are checking public channels for sentiment signals on your selected suppliers.',
  aiGeneratingModalDescription:
    'AI is generating results based on your selection.\n'
    + 'This may take a few moments depending on data availability.',
  aiGeneratingModalContinue: 'Continue in background',
  aiGeneratingMonitoringOverviewTitle: 'Monitoring in progress…',
  aiGeneratingMonitoringOverviewDescription:
    'Follow each monitoring agent that is running. Select a session to open its run history.',
  aiGeneratingButtonHint: 'The results are ready',
  aiGeneratingNothingFoundShort: 'Nothing was found',
  aiGeneratingNothingFound: 'Nothing was found for {{name}}. Please try again.',
  aiGeneratingSearchSuppliersItem: 'Searching suppliers for {{name}}',
  aiGeneratingSearchProductsItem: 'Searching products for {{name}}',
  aiGeneratingBomSessionTitle: 'Products Bill of Materials for {{names}}',
  aiGeneratingStatusDone: 'Done',
  aiGeneratingStatusInProgress: 'In progress',
  aiGeneratingStatusEmpty: 'Not started',
  aiGeneratingStatusAi: 'AI',
  reviewAiGeneratedTitle: 'Review AI Agent Results',
  reviewAiGeneratedBadge: 'AI Generated',
  reviewAiGeneratedDescription:
    'You’re reviewing the generated flow. Remove or adjust cards before applying changes.',
  discardResults: 'Discard results',
  reviewBomGeneratedTitle: 'Review Generated Cards',
  reviewBomGeneratedBadge: 'BOM Generated',
  reviewBomGeneratedDescription:
    'These cards were created from the inputs in your BOM table. '
    + 'Review them before applying changes or return to the BOM to edit the source data.',
  scenario: 'Scenario',
  impactScenariosTitle: 'Impact Scenarios',
  /* The panel's header shows the analysis name. This names the panel itself, for the AI context. */
  impactAnalysisPanelTitle: 'Impact analysis',
  impactScenariosEmptyDescription:
    'You haven’t created any analyses yet.\nStart a new one to explore insights and evaluate your data.',
  impactScenariosSearchPlaceholder: 'Search by name...',
  impactScenariosNoResults: 'No scenarios found',
  startNewAnalysis: 'Start a new analysis',
  startImpactAnalysis: 'Start Impact Analysis',
  analysisSetup: 'Analysis Setup',
  analysisResults: 'Analysis Results',
  noAnalysesYet: 'Run an analysis first to see the results.',
  backToAnalysisSetup: 'Back to Analysis Setup',
  createNewScenario: 'Create New Scenario',
  copyExisting: 'Copy existing',
  copyExistingScenarios: 'Copy Existing Scenarios',
  noExistingScenarios: 'No scenarios found',
  selectExistingScenario: 'Select {{name}}',
  maxScenariosReached: 'You have reached the maximum of {{count}} scenarios',
  untitledAnalysis: 'Untitled',
  loading: 'Loading...',
  deleteAnalysisConfirm: 'Delete',
  deleteAnalysisCancel: 'Cancel',
  addScenarioTitle: 'Add scenario',
  editScenarioTitle: 'Edit scenario',
  scenarioNameLabel: 'Name',
  affectedPeriodLabel: 'Affected Period',
  productivityImpactLabel: 'Productivity Impact (%)',
  affectedEntitiesLabel: 'Affected Entities',
  selectedEntitiesLabel: 'Selected Entities',
  addByCountry: 'Add by Country',
  addViaSearch: 'Add via Search',
  saveScenario: 'Save Scenario',
  noAffectedEntities: 'No affected entities yet Add entities using search or select them by country',
  noCountriesFound: 'No countries found',
  noAffectedEntitiesFound: 'No affected entities found',
  resetAll: 'Reset all',
  clearGroup: 'Clear group',
  clearGroupConfirmTitle: 'Remove all entities in this group?',
  clearGroupConfirmDescription: 'Your configuration will be lost.',
  resetAllConfirmTitle: 'Remove all entities from this scenario?',
  resetAllConfirmDescription: 'Your configuration will be lost.',
  noLocation: 'No location',
  affectedGeography: 'Affected Geography',
  scenarioProductivityImpact: 'Productivity Impact',
  scenarioViewAriaLabel: 'View scenario',
  scenarioEditAriaLabel: 'Edit scenario',
  scenarioDeleteAriaLabel: 'Delete scenario',
  deleteScenarioTitle: 'Remove this scenario from the analysis?',
  deleteScenarioDescription: 'Your configuration will be lost.',
  deleteScenarioHint: 'This action cannot be undone',
  deleteScenarioCancel: 'Cancel',
  deleteScenarioConfirm: 'Delete',
  resultCardImpactedProducts: 'Impacted Products',
  resultCardProfitCentres: 'Profit Centres',
  resultCardImpactedCustomers: 'Impacted Customers',
  resultCardRevenueImpact: 'Customer Revenue Impact',
  resultCardRevenueAtRisk: 'Revenue at risk',
  resultCardProducts: 'products',
  resultCardCentres: 'centres',
  resultCardCustomers: 'customers',
  resultCardOf: 'of',
  resultCardEntities: 'entities',
  resultCardScenarios: 'scenarios',
  resultCardViewDetails: 'View details',
  resultCardHideDetails: 'Hide details',
  resultCardScenariosLabel: 'Scenarios',
  resultCardToggleVisibility: 'Toggle visibility',
  resultCardOpenMenu: 'Open menu',
  resultCardDeleteTitle: 'Are you sure you want to delete this impact analysis?',
  resultCardDeleteDescription: 'This action cannot be undone',
  resultCardDeleteCancel: 'Cancel',
  resultCardDeleteConfirm: 'Delete',
  resultCardDuplicateTitle:
    'Are you sure you want to create a duplicate?',
  resultCardDuplicateCancel: 'Cancel',
  resultCardDuplicateConfirm: 'Duplicate',
  resultCardReRun: 'Re-run',
  resultCardProcessingTitle: 'Analysis in progress...',
  resultCardProcessingDescription:
    'Your data is being processed and scenarios are being applied. Results will appear shortly.',
  resultCardFailedTitle: 'Analysis failed',
  resultCardFailedDescription: 'Could not calculate results',
  periodDays: 'Day',
  periodWeeks: 'Week',
  periodMonths: 'Month',
  periodYears: 'Year',
  view: 'View',
  groupBy: 'Group by:',
  groupByLocation: 'Location',
  groupByBusinessStructure: 'Business Structure',
  groupByCards: 'Cards',
  groupCollapseHint: 'Click group header above to collapse',
  groupShowMoreItems: '+ {{count}} more items in this group',
};
